import type { WidgetProps } from '@rjsf/utils';

import { KeyValue } from '@/components/ui/keyValue/keyValue';
import { RichEditor } from '@/components/ui/richEditor';

type Props = {
  options?: {
    withSubject: boolean;
    withMentions: boolean;
  };
} & Pick<WidgetProps, 'name' | 'value' | 'label'>;

const isJson = string => {
  try {
    JSON.parse(string);
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

export const SlateReaderWidget = ({
  value = '',
  label = 'Comment',
  options = {
    withSubject: false,
    withMentions: false
  },
  name
}: Props) => {
  const isJSON = isJson(value);

  if (label === 'Answer') {
    return (
      <RichEditor
        readOnly
        value={value}
        withMentions={isJSON && options.withMentions}
        withSubject={isJSON && options.withSubject}
      />
    );
  }

  return (
    <KeyValue dataCyName={name} title={label}>
      <RichEditor
        readOnly
        value={value}
        withMentions={isJSON && options.withMentions}
        withSubject={isJSON && options.withSubject}
      />
    </KeyValue>
  );
};
